export const REGISTER_TIMEOUT_SECONDS = 120;
export const ACCOUNT_NUMBER_TIMEOUT_SECONDS = 30;
export const DEFAULT_IDLE_TIME_IN_MINUTES = 30; // 30 min
export const DEFAULT_PROMPT_TIME_IN_MILLISECONDS = 2 * 60 * 1000; // 2 min
export const SESSION_TIMEOUT = 'SESSION_TIMEOUT';
